import React, { useEffect, useState } from "react";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiUrl } from "Services/Services";

function Deals() {
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);

  const fetchDeals = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/deals`);
      if (response.data && response.data.data) {
        setDeals(response.data.data);
      } else {
        console.log("No deals found or invalid response");
      }
    } catch (error) {
      console.error("Error fetching deals:", error.message);
    }
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  // Helper to truncate text
  const truncate = (text, maxLength = 40) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
  };

  const handleDelete = async(id) =>{
    try {
      const res = await axios.delete(`${ApiUrl}/deals/${id}`);
      console.log(res);
      fetchDeals()
    } catch (error) {
      console.log(error.message)
    }
  }
  const handleView = async(id) =>{
    try {
      navigate(`/admin/dealView/${id}`)
    } catch (error) {
      console.log(error.message)
    }
  }
  const handleEdit = async(id) =>{
    try {
      navigate(`/admin/editDeal/${id}`)
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <div className="p-6">
      <div className="flex justify-end items-center mb-6">
        <button
          onClick={() => navigate("/admin/AddDeal")}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          + Add Deal
        </button>
      </div>

      <div className="overflow-x-auto rounded-lg">
        <table className="min-w-full border rounded-lg bg-white">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4">Image</th>
              <th className="py-2 px-4">Deal Name</th>
              <th className="py-2 px-4">Description</th>
              <th className="py-2 px-4">Price</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {deals.length > 0 ? (
              deals.map((deal) => (
                <tr key={deal.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4">
                    <img
                      src={deal.image || "https://via.placeholder.com/60"}
                      alt="deal"
                      className="w-14 h-14 rounded"
                    />
                  </td>
                  <td className="py-2 px-4">{deal.name}</td>
                  <td className="py-2 px-4">{truncate(deal.description, 50)}</td>
                  <td className="py-2 px-4">Rs {deal.price}</td>
                  <td className="py-2 px-4">{deal.status}</td>
                  <td className="px-4 py-3 text-right space-x-2">
                    <button className="text-blue-500 hover:text-blue-700" onClick={()=>{handleView(deal.id)}}>
                      <FaEye />
                    </button>
                    <button className="text-blue-500 hover:text-blue-700" onClick={()=>{handleEdit(deal.id)}}>
                      <FaEdit />
                    </button>
                    <button className="text-red-500 hover:text-red-700"  onClick={() => handleDelete(deal.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center py-4">
                  No deals available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Deals;
